import { Box, Stack, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import { ProcuredQtyCell } from "./ProcuredQtyCell";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export const estCols = [
  {
    accessorKey: "System",
    header: "System",
    size: 220,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Category",
    header: "Category",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Component",
    header: "Component",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "SubComponent",
    header: "SubComponent",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "TagNumber",
    header: "TagNumber",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Size/Rating",
    header: "Size/Rating",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Material",
    header: "Material",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Manufacturer",
    header: "Manufacturer",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Model #",
    header: "Model #",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Qty",
    header: "Qty",
    size: 50,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "UOM",
    header: "UOM",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Item Cost$",
    header: "Item Cost$",
    size: 120,
    enableHiding: false,
    enableSorting: false,
  },
];

// Function to create Summary columns with handlers
export const createSummaryColumns = (
  handleFieldUpdate,
  setTotalSummary,
  totalSummary,
  editingRowIndex = null,
  setEditingRowIndex,
) => [
  {
    accessorKey: "MaterialDescription",
    header: "Material Description",
    enableColumnActions: false,
    size: 200,
    Footer: () => {
      return (
        <Typography sx={{ fontWeight: "bold", ml: 3, mt: 0.5 }}>
          Total
        </Typography>
      );
    },
  },
  {
    accessorKey: "length",
    header: "Req. Qty",
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "procuredQty",
    header: "Procure Qty",
    enableColumnActions: false,
    size: 100,
  },
  {
    accessorKey: "Unit",
    header: "Unit",
    enableColumnActions: false,
    size: 50,
  },
  {
    accessorKey: "unitCost",
    header: "Unit Cost $",
    enableColumnActions: false,
    size: 50,
  },
  {
    accessorKey: "pmBudgetedCost",
    header: "P.M Budgeted Cost %",
    enableColumnActions: false,
    size: 130,
    Cell: ({ row, cell }) => {
      const value = cell.getValue() ?? "";
      const isEditing = editingRowIndex === row.index;
      if (!handleFieldUpdate || !isEditing) {
        return <Typography sx={{ fontSize: "0.875rem" }}>{value}</Typography>;
      }
      return (
        <TextField
          variant="standard"
          size="small"
          value={value}
          onChange={(e) =>
            handleFieldUpdate(
              row.index,
              "pmBudgetedCost",
              e.target.value,
              row.original._projectId,
              row.original._revisionId,
            )
          }
          InputProps={{ disableUnderline: false }}
          sx={{
            "& input": { py: 0.5, px: 0.5, fontSize: "0.875rem" },
            width: "100%",
          }}
          placeholder="0 / +5% / -5%"
        />
      );
    },
    // Footer: ({ table }) => {
    //   const rows = table.getFilteredRowModel().rows;
    //   let total = 0;
    //   rows.forEach((row) => {
    //     const raw = row.original.pmBudgetedCost;
    //     const totalCost =
    //       row.original.procuredQty && row.original.MaterialCost
    //         ? Number(row.original.procuredQty) *
    //           Number(row.original.MaterialCost)
    //         : 0;
    //     if (typeof raw === "string" && raw.trim().endsWith("%")) {
    //       const pct = parseFloat(raw) || 0;
    //       total += totalCost * (1 + pct / 100);
    //     } else {
    //       const num = parseFloat(raw);
    //       total += isNaN(num) ? 0 : num;
    //     }
    //   });
    //   return total ? (
    //     <Box
    //       sx={{
    //         fontSize: "12px",
    //         textAlign: "center",
    //         py: 0.5,
    //         border: "1px solid #444",
    //       }}
    //     >
    //       {total.toFixed(2)}
    //     </Box>
    //   ) : (
    //     ""
    //   );
    // },
  },
  {
    accessorKey: "totalCost",
    header: "Total Cost $",
    enableColumnActions: false,
    size: 100,
    Cell: ({ row }) => {
      return row.original.procuredQty && row.original.unitCost !== "Not Added!"
        ? (
            Number(row.original.procuredQty) * Number(row.original.unitCost)
          ).toFixed(2)
        : "";
    },
    Footer: ({ table }) => {
      let total = 0;

      table
        .getFilteredRowModel()
        .rows.map((row) => row.original)
        .forEach((r) => {
          const totalCost =
            r.procuredQty && r.unitCost !== "Not Added!" && r.MaterialCost
              ? Number(r.procuredQty) * Number(r.MaterialCost)
              : 0;
          total += totalCost;
        });

      return total ? (
        <Box
          sx={{
            fontSize: "12px",
            textAlign: "center",
            py: 0.5,
            border: "1px solid #444",
          }}
        >
          {total.toFixed(2).toString()}
        </Box>
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "totalFabHrs",
    header: "Total Fab (hrs)",
    enableColumnActions: false,
    size: 50,
    // Footer: ({ table }) => {
    //   let total = 0;

    //   table
    //     .getFilteredRowModel()
    //     .rows.map((row) => row.original)
    //     .forEach((r) => {
    //       const totalFabHrs = r.totalFabHrs ? Number(r.totalFabHrs) : 0;
    //       total += totalFabHrs;
    //     });

    //   return total ? (
    //     <Box
    //       sx={{
    //         fontSize: "12px",
    //         textAlign: "center",
    //         py: 0.5,
    //         border: "1px solid #444",
    //       }}
    //     >
    //       {total.toFixed(2).toString()}
    //     </Box>
    //   ) : (
    //     ""
    //   );
    // },
  },

  {
    accessorKey: "pmBudgetedHr",
    header: "P.M Budgeted Hr %",
    enableColumnActions: false,
    size: 130,
    Cell: ({ row, cell }) => {
      const value = cell.getValue() ?? "";
      const isEditing = editingRowIndex === row.index;
      if (!handleFieldUpdate || !isEditing) {
        return <Typography sx={{ fontSize: "0.875rem" }}>{value}</Typography>;
      }
      return (
        <TextField
          variant="standard"
          size="small"
          value={value}
          onChange={(e) =>
            handleFieldUpdate(
              row.index,
              "pmBudgetedHr",
              e.target.value,
              row.original._projectId,
              row.original._revisionId,
            )
          }
          InputProps={{ disableUnderline: false }}
          sx={{
            "& input": { py: 0.5, px: 0.5, fontSize: "0.875rem" },
            width: "100%",
          }}
          placeholder="0"
        />
      );
    },
    Footer: ({ table }) => {
      const rows = table.getFilteredRowModel().rows;
      let total = 0;
      rows.forEach((row) => {
        const num = parseFloat(row.original.pmBudgetedHr);
        total += isNaN(num) ? 0 : num;
      });
      return total ? (
        <Box
          sx={{
            fontSize: "12px",
            textAlign: "center",
            py: 0.5,
            border: "1px solid #444",
          }}
        >
          {total.toFixed(2)}
        </Box>
      ) : (
        ""
      );
    },
  },
];

// Keep backward compatibility - default export without handlers
export const pvEstCols = createSummaryColumns();
export const pvEstBOMCol = [
  {
    accessorKey: "ItemNo",
    header: "Item No",
    enableColumnActions: false,
    size: 50,
  },
  {
    accessorKey: "MaterialDescription",
    header: "Material Description",
    enableColumnActions: false,
    size: 150,
  },
  {
    accessorKey: "Qty",
    header: "Qty",
    enableColumnActions: false,
    size: 50,
  },
  {
    accessorKey: "length",
    header: "Dimension",
    enableColumnActions: false,
    size: 50,
  },
  {
    accessorKey: "Unit",
    header: "Unit",
    enableColumnActions: false,
    size: 50,
  },
  {
    accessorKey: "Weight",
    header: "Weight (Ib)",
    enableColumnActions: false,
    size: 50,
  },
  // {
  //   accessorKey: "Cost (US $)",
  //   header: "Material Cost (US $)",
  //   size: 100,
  //   enableHiding: false,
  //   enableSorting: false,
  // },
  // {
  //   accessorKey: "Total Manhour",
  //   header: "Total Manhour",
  //   size: 50,
  //   enableHiding: false,
  //   enableSorting: false,
  // },
  // {
  //   accessorKey: "Remarks",
  //   header: "Remarks",
  //   size: 100,
  //   enableHiding: false,
  //   enableSorting: false,
  // },
];

export const trimListCols = [
  {
    accessorKey: "Description",
    header: "Description",
    size: 220,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Cost",
    header: "Cost",
    size: 220,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "ManHours",
    header: "ManHours",
    size: 220,
    enableHiding: false,
    enableSorting: false,
  },
];

export const pvSumEst = [
  {
    accessorKey: "Items",
    header: "Items",
    size: 100,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Value",
    header: "Value",
    size: 50,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Manhour Rate (US $)",
    header: "Manhour Rate (US $)",
    size: 50,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Mark Up (%)",
    header: "Mark Up (%)",
    size: 50,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Total Cost (US $)",
    header: "Total Cost (US $)",
    size: 50,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Remarks",
    header: "Remarks",
    size: 100,
    enableHiding: false,
    enableSorting: false,
  },
];

const EstimationColumns = () => [
  {
    accessorKey: "Material Code",
    header: "Material Code",
    size: 100,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Material Description",
    header: "Material Description",
    size: 180,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Estimated Weight",
    header: "Estimated Weight",
    size: 120,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Plate to be procured",
    header: "Plate to be procured",
    size: 140,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Qty",
    header: "Qty",
    size: 60,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
  },
  {
    accessorKey: "Dimension",
    header: "Dimension",
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
  },
  {
    accessorKey: "Unit",
    header: "Unit",
    size: 60,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "MaterialCost",
    header: "Unit Cost",
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Total Cost",
    header: "Total Cost",
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    // muiTableHeadCellProps: { align: "center" },
    size: 100,
  },
  {
    accessorKey: "Manhours",
    header: "Manhours",
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => (
      <>{cell.getValue() ? parseFloat(cell.getValue()).toFixed(2) : ""}</>
    ),
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Remarks",
    header: "Remarks",
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
    // size: "40px"
  },
];

const coerceNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const formatNumber = (value, fractionDigits = 2) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "";
  return parsed.toFixed(fractionDigits);
};

const computeTotalWeight = (row) => {
  const qty = coerceNumber(row?.Qty);
  const length = coerceNumber(row?.length);
  const unitWeight = coerceNumber(row?.UnitWeight);
  const total = qty * length * unitWeight;
  return total ? formatNumber(total) : "";
};

const computeTotalSA = (row) => {
  const qty = coerceNumber(row?.Qty);
  const unitSA = coerceNumber(row?.UnitSA);
  const total = qty * unitSA;
  return total ? formatNumber(total) : "";
};

const computeTotalFab = (row) => {
  const totalWeight = coerceNumber(computeTotalWeight(row));
  const fabRate = coerceNumber(row?.FabRate);
  const total = totalWeight * fabRate;
  return total ? formatNumber(total) : "";
};
export const structuralEstCols = [
  {
    accessorKey: "Spec",
    header: "Spec",
    size: 70,
    enableSorting: false,
    enableHiding: false,
    muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Components",
    header: "Component",
    size: 130,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "Size",
    header: "Size",
    size: 100,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "Material",
    header: "Material",
    size: 100,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "MaterialDescription",
    header: "Material Description",
    size: 180,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "OriginalSizeRange",
    header: "Original Size Range",
    size: 150,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "Qty",
    header: "Qty",
    size: 60,
    enableSorting: false,
    enableHiding: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => formatNumber(cell.getValue(), 0),
  },
  {
    accessorKey: "length",
    header: "Dimension",
    size: 90,
    enableSorting: false,
    enableHiding: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => formatNumber(cell.getValue()),
  },
  {
    accessorKey: "Unit",
    header: "Unit",
    size: 60,
    enableSorting: false,
    enableHiding: false,
    muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "UnitWeight",
    header: "Unit Weight (lb/ft)",
    size: 130,
    enableSorting: false,
    enableHiding: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => formatNumber(cell.getValue()),
  },
  {
    accessorKey: "totalWeight",
    header: "Total Weight (lb)",
    size: 120,
    enableSorting: false,
    enableHiding: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ row }) => computeTotalWeight(row.original),
  },
  {
    accessorKey: "UnitSA",
    header: "Unit SA (ft²/ft)",
    size: 110,
    enableSorting: false,
    enableHiding: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => formatNumber(cell.getValue()),
  },
  {
    accessorKey: "totalSA",
    header: "Total SA (ft²)",
    size: 110,
    enableSorting: false,
    enableHiding: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ row }) => computeTotalSA(row.original),
  },
  // {
  //   accessorKey: "MaterialRate",
  //   header: "Material Rate",
  //   size: 110,
  //   enableSorting: false,
  //   enableHiding: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => formatNumber(cell.getValue()),
  // },
  {
    accessorKey: "FabRate",
    header: "Fab Rate (hrs/lb)",
    size: 110,
    enableSorting: false,
    enableHiding: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => formatNumber(cell.getValue()),
  },
  {
    accessorKey: "totalFabHrs",
    header: "Total Fab (hours)",
    size: 120,
    enableSorting: false,
    enableHiding: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ row }) => computeTotalFab(row.original),
  },
  {
    accessorKey: "Painted",
    header: "Painted",
    size: 110,
    enableSorting: false,
    enableHiding: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ row }) =>
      row.original.Painted ? (
        <CheckCircleIcon color="success" />
      ) : (
        <CancelIcon color="error" />
      ),
  },
  {
    accessorKey: "Galvanized",
    header: "Galvanized",
    size: 120,
    enableSorting: false,
    enableHiding: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ row }) =>
      row.original.Galvanized ? (
        <CheckCircleIcon color="success" />
      ) : (
        <CancelIcon color="error" />
      ),
  },
  {
    accessorKey: "FireProofed",
    header: "Fire Proofed",
    size: 130,
    enableSorting: false,
    enableHiding: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ row }) =>
      row.original.FireProofed ? (
        <CheckCircleIcon color="success" />
      ) : (
        <CancelIcon color="error" />
      ),
  },
  {
    accessorKey: "stockQty",
    header: "Material @ Stock",
    size: 120,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "Requirements",
    header: "Requirements",
    size: 150,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    size: 100,
    enableSorting: false,
    enableHiding: false,
  },
];
const createTotalFooter =
  (key, fractionDigits = 2) =>
  ({ table }) => {
    const total = table
      .getFilteredRowModel()
      .rows.reduce((sum, row) => sum + coerceNumber(row.original[key]), 0);

    if (!total) return "";

    return (
      <Box
        sx={{
          fontSize: "12px",
          textAlign: "center",
          py: 0.5,
          border: "1px solid #444",
        }}
      >
        {total.toFixed(fractionDigits)}
      </Box>
    );
  };

export const SummaryColumns = () => [
  {
    accessorKey: "MaterialDescription",
    header: "Material Description",
    size: 200,
    enableSorting: false,
    Footer: () => (
      <Typography sx={{ fontWeight: "bold", ml: 3, mt: 0.5 }}>Total</Typography>
    ),
  },
  {
    accessorKey: "length",
    header: "Req. Qty",
    size: 100,
    enableSorting: false,
  },
  {
    accessorKey: "procuredQty",
    header: "Procured Qty",
    size: 120,
    enableSorting: false,
  },
  {
    accessorKey: "Unit",
    header: "Unit",
    size: 60,
    enableSorting: false,
  },
  // {
  //   accessorKey: "Weight",
  //   header: "Total Weight (lb)",
  //   size: 120,
  //   enableSorting: false,
  //   Footer: createTotalFooter("Weight"),
  // },
  {
    accessorKey: "unitCost",
    header: "Unit Cost ($)",
    size: 110,
    enableSorting: false,
  },
  {
    accessorKey: "totalCost",
    header: "Total Cost ($)",
    size: 140,
    enableSorting: false,
    Cell: ({ row }) => {
      const weight = coerceNumber(row.original.Weight);
      const unitCost = coerceNumber(row.original.unitCost);
      const total = weight * unitCost;
      return total ? formatNumber(total) : "";
    },
    Footer: createTotalFooter("totalCost"),
  },
  {
    accessorKey: "totalFabHrs",
    header: "Total Fab (hrs)",
    size: 120,
    enableSorting: false,
    Footer: createTotalFooter("totalFabHrs"),
  },
];

export const NozzleEstimationColumns = () => {
  return [
    {
      accessorKey: "Mark",
      header: "Mark",
      size: 30,
      enableSorting: false,
      muiTableHeadCellProps: { align: "center" },
    },
    {
      accessorKey: "Flange_Weight",
      header: "Flange Weight (Kg).",
      size: 30,
      enableSorting: false,
      muiTableHeadCellProps: { align: "center" },
    },
    {
      accessorKey: "Pipe_Weight",
      header: "Pipe Weight (Kg)",
      size: 30,
      enableSorting: false,
      muiTableHeadCellProps: { align: "center" },
    },
    {
      accessorKey: "Pad_Weight",
      header: "Pad Weight (Kg)",
      size: 30,
      enableSorting: false,
      muiTableHeadCellProps: { align: "center" },
    },
    {
      accessorKey: "Total_Wieght",
      header: "Total Weight (Kg)",
      size: 30,
      enableSorting: false,
      muiTableHeadCellProps: { align: "center" },
    },
    {
      accessorKey: "Model_Wieght",
      header: "3D Model Weight (Kg)",
      size: 30,
      enableSorting: false,
      muiTableHeadCellProps: { align: "center" },
    },
    {
      accessorKey: "Weld_Manhour",
      header: "Weld Manhour",
      size: 30,
      enableSorting: false,
      muiTableHeadCellProps: { align: "center" },
    },
    {
      accessorKey: "Bolt_Manhour",
      header: "Bolt Manhour",
      size: 30,
      enableSorting: false,
      muiTableHeadCellProps: { align: "center" },
    },
    {
      accessorKey: "NDT_Cost",
      header: "NDT Cost ($)",
      size: 30,
      enableSorting: false,
      muiTableHeadCellProps: { align: "center" },
    },
  ];
};

export const AddToFabricationColumns = [
  // {
  //   accessorKey: "Material Code",
  //   header: "Material Code",
  //   size: 120,
  //   enableSorting: false,
  //   // muiTableHeadCellProps: { align: "center" },
  // },
  {
    accessorKey: "Cost Code",
    header: "Cost Code",
    size: 100,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Components",
    header: "Componenet / Description",
    size: 220,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Qty",
    header: "Quantity",
    size: 50,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => (
      <>{cell.getValue() ? parseFloat(cell.getValue()).toFixed(2) : ""}</>
    ),
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Total Manhour",
    header: "Total Manhour",
    size: 50,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => (
      <>{cell.getValue() ? parseFloat(cell.getValue()).toFixed(2) : ""}</>
    ),
    // muiTableHeadCellProps: { align: "center" },
  },
];

export default EstimationColumns;

export const tabLabels = ["Estimation", "Summary", "BOM"];
